"use client";
import Link from "next/link";
import { useState } from "react";
import { addFilter } from "./utils";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";

export const FiltersList = ({ facets, fullUrl }) => {
  // State para controlar la cantidad de items visibles por filtro
  const [visibleCount, setVisibleCount] = useState({});

  const handleShowMore = (facetName, currentCount, totalCount) => {
    setVisibleCount((prev) => ({
      ...prev,
      [facetName]:
        currentCount + 5 > totalCount ? totalCount : currentCount + 5,
    }));
  };

  const handleShowLess = (facetName) => {
    setVisibleCount((prev) => ({
      ...prev,
      [facetName]: 5, // Reset to initial count
    }));
  };

  return facets.map(({ facet, data }) => {
    const currentVisibleCount = visibleCount[facet.name] || 5;
    const entries = Object.entries(data);
    const visibleEntries = entries.slice(0, currentVisibleCount);

    return (
      Object.entries(data).length > 0 && (
        <div
          key={`key-${facet.name}`}
          className="mb-5 bg-white rounded-lg shadow-lg w-full border"
        >
          <div className="font-bold bg-blue-800 text-white p-2 rounded rounded-b-none text-center">
            <h4 className="text-sm">{facet.label}</h4>
          </div>

          {visibleEntries.map(([key, value]) => (
            <Link
              key={key}
              href={addFilter(fullUrl, `${facet.name}:"${key}"`)}
              className="hover:text-blue-900 hover:underline hover:font-bold"
            >
              <div className="flex flex-row p-2 gap-4 justify-between">
                <span>{key}</span>
                <span>({value})</span>
              </div>
            </Link>
          ))}

          <div className="flex justify-center gap-5 my-2 text-blue-700">
            {currentVisibleCount < entries.length && (
              <button
                className="flex items-center gap-1 hover:font-bold "
                onClick={() =>
                  handleShowMore(
                    facet.name,
                    currentVisibleCount,
                    entries.length
                  )
                }
              >
                Ver más <IoChevronDown />
              </button>
            )}
            {currentVisibleCount > 5 && (
              <button
                className="flex items-center gap-1 hover:font-bold"
                onClick={() => handleShowLess(facet.name)}
              >
                Ver menos <IoChevronUp />
              </button>
            )}
          </div>
        </div>
      )
    );
  });
};
